import React from "react";
import "./Hero.css";
import { motion } from "framer-motion";

const Hero = ({ onContactClick }) => {
	return (
		<section className="hero">
			<div className="hero-image-wrapper">
				<img
					src="https://images.pexels.com/photos/7221143/pexels-photo-7221143.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop"
					alt="Elegant rose gold balloon arrangement for celebration"
					className="hero-image"
				/>
				<div className="hero-overlay" />
			</div>

			<motion.div
				className="hero-content"
				initial={{ opacity: 0, y: 30 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 1, delay: 0.3 }}
			>
				<p className="hero-label">Aire Studio</p>
				<h1 className="hero-title">Elevate Every Celebration</h1>
				<p className="hero-subtitle">
					Bespoke balloon bouquets, curated gift baskets & stunning balloon arches
					crafted for life's most beautiful moments.
				</p>
				<div className="hero-actions">
					<button className="hero-btn-primary" onClick={onContactClick}>
						Get in Touch
					</button>
					<button
						className="hero-btn-secondary"
						onClick={() => {
							const el = document.getElementById("categories");
							if (el) el.scrollIntoView({ behavior: "smooth" });
						}}
					>
						Explore
					</button>
				</div>
			</motion.div>
		</section>
	);
};

export default Hero;
